
    import has from 'lodash/has';
    import { mapState, mapMutations, mapGetters, mapActions } from 'vuex';

    import LoginRegister from '@/components/Auth/LoginRegister';
    import ApplyForm from '@/components/JobView/Apply/ApplyForm';
    import ApplyFormNewUser from '@/components/JobView/Apply/ApplyFormNewUser';
    import ApplyFormGuest from '@/components/JobView/Apply/ApplyFormGuest';
    import Auth from '@/components/AuthApollo/Auth';
    import ApplyMixin from '@/components/JobView/Apply/ApplyMixin';
    import { jobData } from '@/utils/jobData';
    import datalayer from '@/utils/datalayer';

    export default {
        name: 'Apply',

        components: {
            ApplyForm,
            ApplyFormNewUser,
            ApplyFormGuest,
            LoginRegister,
            Auth,
        },

        mixins: [ApplyMixin],

        data() {
            return {
                continueWithEmailCheck: false,
                applyEventAlreadyStarted: false,
            };
        },

        computed: {
            ...mapState({
                $_me: state => state.me.user,
                $_jobApplication: state => state.jobApplication,
            }),

            ...mapGetters('job', {
                $_companyName: 'companyName',
                $_companyLink: 'companyLink',
                $_locationLabel: 'locationLabel',
                $_locationLink: 'locationLink',
                $_isPrivateListing: 'isPrivateListing',
                $_jobTitle: 'jobTitle',
            }),

            ...mapGetters('me', {
                $_isOnboarded: 'isOnboarded',
            }),

            ...mapGetters('jobApplication', {
                $_applyEmail: 'applyEmail',
                $_isApplyTypeSeeker: 'isApplyTypeSeeker',
                $_isApplyTypeNew: 'isApplyTypeNew',
                $_isApplyTypeGuest: 'isApplyTypeGuest',
            }),

            isRecognisedUser() {
                return has(this.$_jobApplication, 'user.id');
            },

            canSocialLogin() {
                return !this.$isApp;
            },
        },

        created() {
            this.changeApplyTypeToSeeker();
        },

        mounted() {
            if (!this.$_me.id) {
                this.eventJobApplyAuthImpression();
            }
        },

        methods: {
            ...mapMutations('jobApplication', {
                $_CLOSE_APPLY_FORM: 'CLOSE_APPLY_FORM',
                $_STORE_USER: 'STORE_USER',
                $_STORE_APPLY_TYPE_SEEKER: 'STORE_APPLY_TYPE_SEEKER',
                $_STORE_APPLY_TYPE_GUEST: 'STORE_APPLY_TYPE_GUEST',
                $_STORE_APPLY_TYPE_NEW: 'STORE_APPLY_TYPE_NEW',
            }),

            ...mapActions('eventTracking', {
                $_pushEvent: 'pushEvent',
            }),

            onUserChange(user) {
                this.$_STORE_USER(user);
                if (!this.applyEventAlreadyStarted) {
                    this.eventJobApplyStart();
                    this.applyEventAlreadyStarted = true;
                }
                if (user.id) {
                    this.$_STORE_APPLY_TYPE_GUEST();
                } else {
                    this.$_STORE_APPLY_TYPE_NEW();
                }
            },

            changeApplyTypeToSeeker() {
                if (this.$_me.id) {
                    if (!this.applyEventAlreadyStarted) {
                        this.eventJobApplyStart();
                        this.applyEventAlreadyStarted = true;
                    }
                    this.$_STORE_APPLY_TYPE_SEEKER();
                }
            },

            loginResponse(response) {
                this.changeApplyTypeToSeeker();
                this.$emit('afterLogin', response);
            },

            onContinueWithEmail() {
                this.continueWithEmailCheck = true;
            },

            onSkipRegister() {
                this.handleRedirect();
            },

            onBeforeRegister() {
                this.onContinueApply();
            },

            onContinueApply() {
                this.eventJobOffsiteApplyRedirect();
                window.open(this.getOffsiteApplyUrl, '_blank');
            },

            handleRedirect() {
                if (this.$route.name === 'jobview-slug-id') {
                    this.$router.push(this.redirectUrl);
                } else {
                    this.$_CLOSE_APPLY_OFFSITE_FORM();
                    this.$_CLOSE_APPLY_FORM();
                }
                this.eventJobOffsiteApplyRedirect();
            },

            eventJobOffsiteApplyRedirect() {
                const data = {
                    event: 'job_offsite_apply_redirect',
                    site_position: 'job_apply',
                    ...jobData(this.$_job),
                };
                datalayer(data);
                this.$_pushEvent(data);
            },
        },
    };
